export default "__VITE_ASSET__CwYw9Pea__"